import { API_URLS, customAxios } from '../config';

export const addLocation = payload => customAxios.post(API_URLS.addUpdateLocations, payload).catch(ex => ({data:{message : "Some error occured, Please try after sometime."}}));;
export const getLocation = () => customAxios.post(API_URLS.getLocations).catch(ex => ({data:{message : "Some error occured, Please try after sometime."}}));;
export const getStores = payload => customAxios.post(API_URLS.getStores, payload).catch(ex => ({data:{message : "Some error occured, Please try after sometime."}}));;

// eslint-disable-next-line import/no-anonymous-default-export
export default { addLocation, getLocation, getStores };
